import { connect } from 'react-redux'
import { getReferralsList } from '../actions/actions-referrals'
import { getProgramsAssignedToLoginList } from '../actions/actions-programs'
import Referrals from '../views/Referrals/referrals'
const mapStateToProps = (state, ownProps) => {
  return {
    parentProps: ownProps,
    referrals: state.referralsR.dataList,
    programsAssigned: state.programsR.programsassignedtologin,
  }
}
const mapDispatchToProps = dispatch => {
  return {
    getReferrals: loginID => {
      dispatch(getReferralsList(loginID))
    },
    getProgramsAssignedToLoginList: id => {
      dispatch(getProgramsAssignedToLoginList(id))
    }
  }
}
const ReferralListContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Referrals)
export default ReferralListContainer
